import { ThemeProvider } from 'styled-components';
import modules from 'build/modules';

export const Theme = ({ children }) => (
  <ThemeProvider theme={modules.json}>{children}</ThemeProvider>
);